<template>
  <div>
    <!-- 英文国赛选手信息 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
        }"
        >个人赛考务管理</el-breadcrumb-item
      >
      <el-breadcrumb-item
        :to="{
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_schedules/nationalgroup_raceManagement',
        }"
        >国赛有组别</el-breadcrumb-item
      >
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header> -->
    <!-- 筛选 -->
    <el-card>
      <el-row class="title_row">
        <el-col>
          <span class="title_class">参赛信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="80px"
        ref="queryFormRef"
      >
        <el-row :gutter="50">
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名" prop="engName">
              <el-input
                v-model="queryForm.engName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学校" prop="schoolName">
              <el-input
                v-model="queryForm.schoolName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="注册状态" prop="isLogin">
              <el-select
                placeholder="请选择类型"
                style="width: 100%"
                v-model="queryForm.isLogin"
              >
                <el-option label="已注册" value="1"></el-option>
                <el-option label="未注册" value="0"></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 比赛信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="2.5">
          <span class="title_class">参赛信息列表</span>
        </el-col>
      </el-row>
      <!-- 英文国赛选手列表 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <!-- <el-table-column label="赛区" prop="districtName"></el-table-column> -->
        <el-table-column
          label="学校"
          prop="schoolName"
          width="220px"
        ></el-table-column>
        <el-table-column label="姓名" prop="engName"></el-table-column>
        <el-table-column label="年级" prop="engGrade"></el-table-column>
        <el-table-column label="是否注册小程序" prop="userId">
          <template slot-scope="scope">
            <el-tag :type="scope.row.userId ? 'success' : 'info'" size="mini">{{ scope.row.userId ? '已注册' : '未注册' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="电话"
          prop="phone"
        ></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="small"
              @click="changeUserInfo(scope.row)"
              >修改信息</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 修改用户信息 -->
    <el-dialog
      title="修改信息"
      :visible.sync="changeUserInfoDialogVisible"
      @close="changeUserInfoDialogClose"
      width="35%"
    >
      <el-form
        :model="changeUserInfoForm"
        :rules="changeUserInfoFormRules"
        class="filter_Form"
        label-width="100px"
        ref="changeUserInfoFormRef"
      >
        <el-form-item label="姓名" prop="engName">
          <el-input v-model="changeUserInfoForm.engName" disabled></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="schoolName">
          <el-input v-model="changeUserInfoForm.schoolName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="changeUserInfoForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeUserInfoDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="changeUserInfoClicked"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import areaJson from '@/assets/area.json'
import $common from '@/methods/common.js'
import { queryDistrictPage, queryNationEngPage, updateNationEngPage } from '@/http/api'
export default {
  data () {
    return {
      changeUserInfoForm: {
      },
      changeUserInfoDialogVisible: false,
      queryForm: {
        schoolId: '',
        districtId: '',
        gender: '',
        grade: [],
        pageNum: 1,
        pageSize: 10,
        phone: '',
        engName: '',
        season: this.$chnEngStatusCode.defaultSeason,
        activityType: this.$chnEngStatusCode.activityType,
        isLogin: ''
      },
      changeUserInfoFormRules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      total: 0,
      areasData: areaJson.areas,
      dataList: [],
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dict_gender: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.dict_gender = value })
    }
  },
  created () {
    // this.getDistrictList()
  },
  computed: {
    $common () { return $common } // 公共方法
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        this.searchFn()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getNationalPlayerInfo()
    },
    // 获取英文国赛选手信息信息
    async getNationalPlayerInfo () {
      queryNationEngPage(this.queryForm).then((res) => {
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 用户点击跳转用户详情
    handleToUserDetails (userId) {
      this.$router.push({
        path: '/c_data_Management/c_player_registInfo_details',
        query: { userId }
      })
    },
    // 修改用户信息
    changeUserInfo (rowData) {
      this.changeUserInfoForm = rowData
      this.changeUserInfoDialogVisible = true
    },
    changeUserInfoDialogClose () {
      this.$refs.changeUserInfoFormRef.resetFields()
      this.changeUserInfoDialogVisible = false
    },
    reset () {
      this.queryForm.phone = ''
      this.queryForm.engName = ''
      this.queryForm.schoolName = ''
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.$refs.queryFormRef.resetFields()
      this.getNationalPlayerInfo()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getNationalPlayerInfo()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getNationalPlayerInfo()
    },
    // 修改点击事件
    changeUserInfoClicked () {
      this.$confirm('请再次确认是否修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.changeUoloadData()
      }).catch(() => { })
    },
    // 确认修改
    async changeUoloadData () {
      updateNationEngPage(this.changeUserInfoForm).then((res) => {
        this.$message.success('保存成功')
        this.getNationalPlayerInfo()
        this.changeUserInfoDialogClose()
      }).catch((err) => {
        console.log('err', err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.input {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
}
.exam_span_class {
  font-size: 14px;
  font-weight: 600;
  line-height: 30px;
  font-weight: 500;
  color: #616161;
}
.topmenu-backview {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  justify-content: flex-start;
}
.paycost_span_class {
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  height: 40px;
  padding: 0px 10px;
  font-weight: 500;
  color: #616161;
}
.change_paycost_btn {
  width: 140px;
  height: 40px;
  margin-left: 20px;
}
.table_span_class {
  font-size: 8px;
  color: #616161;
}
.Title {
  font-size: 16px !important;
  color: black !important;
}
.redcolor {
  color: red;
}
.lightgreen-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.payment-Voucher-class {
  width: 80px;
  height: 80px;
}
.bottom-paycost-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.paycost-info-title {
  width: 100%;
  text-align: right;
  font-size: 16px;
  line-height: 30px;
  font-weight: 900;
}
.paycost-info-img {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.paycostinfo-lefttitle {
  font-size: 16px;
  margin-top: 10px;
  line-height: 30px;
  font-weight: 900;
}
.elformitemclass {
  margin-bottom: 0px !important;
}
.paycost-parents {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.userlist-back {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 30px;
}
.userSelectimg {
  width: 20px;
  height: 20px;
}
.userlist-backview {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
}
.userSelectimg {
  width: 20px;
  height: 20px;
}

.userSelectStr {
  width: 350px;
  font-size: 16px;
  color: black;
  text-align: left;
  margin-left: 10px;
}
.userSelectStrchild {
  width: 210px;
  font-size: 16px;
  color: black;
  text-align: left;
}
.userSelectStrchildView {
  width: 240px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.marageTop {
  margin-top: 20px;
}
.childStr-class {
  font-size: 12px;
}
.numberInputclasschild {
  width: 130px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.upOrDownClass {
  width: 20px;
  height: 20px;
}
.fellowNumberClass {
  font-size: 16px;
  color: black;
  text-align: center;
  padding: 0px 20px;
}
.userInfoStr {
  font-size: 16px;
  text-align: left;
  color: black;
  /* height: 60rpx;
      line-height: 60rpx; */
}
.roomNumberStr {
  font-size: 16px;
  text-align: left;
  color: black;
  text-align: right;
  font-weight: 700;
}
.homeNumberView {
  width: 80%;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 16px;
  color: black;
  background-color: #fec200;
  border-radius: 12.5px;
}
.lineView {
  width: 100%;
  height: 1px;
  background-color: black;
  margin: 20px 0px;
}

.marginBottom {
  margin-bottom: 20px;
}
.couponsTitleStr {
  font-size: 16px;
  color: black;
  text-align: left;
  font-weight: 900;
}

.couponsPriceStr {
  font-size: 16px;
  font-weight: 700;
  color: black;
  text-align: right;
}
.changePriceStr {
  font-size: 12px;
  color: rgb(42, 81, 255);
  text-align: right;
  text-decoration: underline;
}
.footer-view {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.SelectPriceStr {
  font-size: 16px;
  font-weight: 700;
  color: black;
  text-align: center;
  position: absolute;
  right: 70px;
}
.redcolor {
  color: red;
  font-size: 20px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
.div_algin_right {
  text-align: right;
}
</style>
